module.exports = __webpack_public_path__ + "images/upload-file-ce2c71d760500b22d4ced6cafa0ec82e.svg";